import { render, staticRenderFns } from "./EventNomineesComponentView.vue?vue&type=template&id=e8b0cae8&scoped=true"
import script from "./EventNomineesComponentView.vue?vue&type=script&lang=js"
export * from "./EventNomineesComponentView.vue?vue&type=script&lang=js"
import style0 from "./EventNomineesComponentView.vue?vue&type=style&index=0&id=e8b0cae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b0cae8",
  null
  
)

export default component.exports